// Common layout classes
export const LAYOUT_CLASSES = {
  container: 'w-full bg-transparent flex flex-col min-h-screen',
  main: 'flex-1 w-full px-4 sm:px-6 pt-[23px] sm:py-12 bg-white',
  section: 'mb-8 last:mb-0',
  grid: 'grid gap-4 sm:gap-6',
  flexCenter: 'flex items-center justify-center',
  flexBetween: 'flex items-center justify-between'
} as const;

// Button classes
export const BUTTON_CLASSES = {
  primary: 'bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors',
  secondary: 'bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-2 px-4 rounded-lg transition-colors',
  danger: 'bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-4 rounded-lg transition-colors',
  ghost: 'hover:bg-gray-100 text-gray-700 font-medium py-2 px-4 rounded-lg transition-colors'
} as const;

// Input classes
export const INPUT_CLASSES = {
  base: 'w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent',
  textarea: 'w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none',
  select: 'w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white'
} as const;

// Card classes
export const CARD_CLASSES = {
  base: 'bg-white rounded-lg shadow-sm border border-gray-200',
  hover: 'bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow',
  padding: 'p-4 sm:p-6'
} as const;

// Text classes
export const TEXT_CLASSES = {
  heading: 'text-xl sm:text-2xl font-bold text-gray-900',
  subheading: 'text-lg font-semibold text-gray-800',
  body: 'text-gray-600',
  small: 'text-sm text-gray-500',
  error: 'text-red-600 text-sm'
} as const;

// Responsive breakpoints
export const BREAKPOINTS = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px'
} as const;
